import "./RadioButton.scss";
import { useState } from "react";

const RadioButton = ({
  children,
  value,
  name,
  id,
  isDisabled = false,
  checked = false,
  setRadioValue = () => {},
  isControlled = false,
  ...props
}) => {
  const [isChecked, setIsChecked] = useState(checked);
  return (
    <label
      htmlFor={id}
      className="d-flex align-items-center cursor-pointer"
      style={{ gap: "5px" }}
    >
      <span className={"custom-radio"}>
        <input
          type="radio"
          className={"custom-radio__input"}
          value={value}
          name={name}
          id={id}
          disabled={isDisabled}
          defaultChecked={isChecked}
          checked={isControlled ? checked : undefined}
          onChange={(e) => {
            setRadioValue(e?.target?.value);
            setIsChecked(!isChecked);
          }}
          {...props}
        />
        <label htmlFor={id} className={"custom-radio__tag"}></label>
      </span>

      {children ? <span htmlFor={id}>{children}</span> : null}
    </label>
  );
};
export default RadioButton;
